import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { NormativaI } from "interfaces/Normativa";
import { Dropdown } from "react-bootstrap";
import {
  deleteNormativa,
  getDocumentacionFile,
  openFile,
} from "services/normativas";

interface Props {
  elemento: NormativaI;
  onClickEdit: (elemento: NormativaI) => void;
  refreshTable: () => void;
  onClickShowDetail: (elemento: NormativaI) => void;
}

export const NormativasRowActions = ({
  elemento,
  onClickEdit,
  onClickShowDetail,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteNormativa(id);
      showSuccessToast("¡La normativa fue eliminada con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando la normativa: ", error.message);
    }
  };

  const onClickVerDocumento = (id: string | number) => {
    getDocumentacionFile({ id, fileName: "" }).then((file) => {
      if (file) {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    });
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickShowDetail(elemento)}>
          Ver documentos
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar resolución"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la resolución {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
